module.exports = __webpack_public_path__ + "media/images/icon-easy-66ed12b9e235b6c45cde4b845cdb965d.png";